const STATS = [
  { value: "500+", label: "Indian families protected" },
  { value: "₹99", label: "lifetime peace of mind" },
  { value: "10 min", label: "average completion time" },
  { value: "1925", label: "Succession Act compliant" },
];

export default function StatsStrip() {
  return (
    <section className="border-y border-[#0A1128]/10 bg-[#FBF7EE]/40" data-testid="stats-strip">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-8 px-5 py-10 sm:grid-cols-4 sm:px-8">
        {STATS.map((s, i) => (
          <div
            key={i}
            className="text-center sm:text-left sm:[&:not(:first-child)]:border-l sm:[&:not(:first-child)]:border-[#0A1128]/10 sm:[&:not(:first-child)]:pl-6"
            data-testid={`stats-strip-item-${i}`}
          >
            <div className="font-serif text-3xl text-navy sm:text-4xl">{s.value}</div>
            <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#4A5568]">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
